import React from "react";
import { Grid, makeStyles } from "@material-ui/core";
import LoginScreenBanner from "../../shared-resources/images/LeftPanelLoginScreens.png";
import Loading from "../../common-components/Loading";

function AuthWrapper({ children, isAzure, loading }) {
  const useStyles = makeStyles((theme) => ({
    "@global": {
      body: {
        overflow: "hidden",
      },
    },
    loginwrapper: {
      background: "#fff",
      textAlign: "center",
    },
    fieldStyle: {
      width: "60%",
      margin: "8px auto",
    },
    welcomeHead: {
      fontSize: theme.spacing(3),
      letterSpacing: "0px",
      color: "#3D3D3D",
      opacity: "1",
      marginBottom: theme.spacing(1.5),
      fontWeight: 600,
    },
    loginNote: {
      fontSize: theme.spacing(1.75),
      letterSpacing: "0px",
      marginBottom: theme.spacing(1.5),
    },
    welcomeWrapper: {
      // Removed top margin to allow proper centering
      width: "100%",
    },
    loginBtn: {
      textTransform: "none",
      borderRadius: theme.spacing(3),
      background: "#0176D3 !important",
      fontWeight: 500,
      width: "60%",
      marginTop: theme.spacing(4),
      padding: "12px 0 !important",
    },
    fieldsGrid: {
      position: "relative",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      minHeight: "100vh",
    },
    bannerSection: {
      background: "#2354E8",
    },
    loginGrid: {
      height: window.innerHeight + 32,
    },
    loginBanner: {
      marginTop: "45%",
    },
    forgotPswLink: {
      color: "#3D3D3D !important",
      cursor: "pointer",
    },
    formAlt: {
      height: "auto !important",
      position: "static !important",
    },
  }));

  const classes = useStyles();

  return (
    <>
      {!process.env.IS_PROD && (
        <div className={classes.loginwrapper}>
          <Grid container spacing={4} className={classes.loginGrid}>
            <Grid
              item
              lg={6}
              className={classes.bannerSection}
              direction="column"
              alignItems="center"
              justifyContent="center"
              style={{ minHeight: "100vh" }}
            >
              <div className={classes.loginBanner}>
                <img src={LoginScreenBanner} style={{ width: "330px" }} />
              </div>
            </Grid>
            <Grid item className={classes.fieldsGrid} lg={6}>
              <form className={classes.formAlt}>
                <div className={classes.welcomeWrapper}>
                  <Grid container>{children}</Grid>
                </div>
              </form>
            </Grid>
          </Grid>
          {loading && <Loading />}
        </div>
      )}
    </>
  );
}

export default AuthWrapper;
